<template>
  <div class="judgment_detail_box border_box" @click="hideCopyContentfun">
    <div class="tab_bar_box border_box flex_v_center">
      <div class="left_box">
        <i class="back_icon" @click="goback"></i>
      </div>
      <div class="right_box">
        <i class="copy_icon" @click.stop="showCopyContentfun"></i>
        <div class="copy_content" :class="showCopyContent?'active':''">
          <p @click="copyInfo(1)">复制全部</p>
          <p @click="copyInfo(1,k)" v-for="(item,k) of userCopyTemplate" :key="item.id">{{ item.templateName }}</p>
          <p @click="copyInfo(2)">复制标题和链接</p>
          <p @click="copyInfo(3)">复制标题和正文</p>
        </div>
      </div>
    </div>
    <div :class="isIOS?'marginbotm2':'marginbotm'">
      <div class="detail_content_box">
        <div class="info_box border_box">
          <!-- 预警级别 -->
          <!-- <div class="info_level_box border_box">
            <div class="info_level level_00" v-if="detailInfo.warningLevel == 0">普通</div>
            <div class="info_level level_01" v-else-if="detailInfo.warningLevel == 1">中等</div>
            <div class="info_level level_02" v-else-if="detailInfo.warningLevel == 2">严重</div>
            <div class="info_level level_03" v-else-if="detailInfo.warningLevel == 3">高危</div>
          </div> -->
          <h1 class="info_title">
            <!-- 预警级别 -->
            <warningLevel
              v-if="CONSTANT.WARNING_LEVEL.includes(detailInfo.warningClass)"
              :warning-level="detailInfo.warningClass"
              :warning-time-array="detailInfo.warningTimeArray"
              class-name="level-push-warning-list"
            ></warningLevel>
            <span class="info_title" v-html="detailInfo.title" style="margin-right:10px"></span>
            <div class="copy_box" @click="copyInfo(4)">
              <div class="copy_blue_icon"></div>
            </div>
          </h1>
          <div class="info_source_time_box border_box flex_v_center">
            <p>
              <span class="info_tendency zheng" v-if="detailInfo.orientation == 1">正</span>
              <span class="info_tendency fu" v-else-if="detailInfo.orientation == 2">负</span>
              <span class="info_tendency zhong" v-else-if="detailInfo.orientation == 3">中</span>
              <span ref="source" :style="'width:'+ leftWidth / 75 + 'rem'" class="info_source ellipsis" @click.stop="showFullSourceinfo(detailInfo.webname,leftWidth)">{{detailInfo.webname}}</span>
              <span ref="author" :style="'width:'+ centerWidth / 75 + 'rem'" class="info_author ellipsis" @click.stop="showFullAuthorinfo(detailInfo.author,centerWidth)">{{detailInfo.author}}</span>
            </p>
            <p>
              <span ref="time" class="info_time">{{detailInfo.publishTime}}</span>
            </p>
          </div>
          <p v-show="isShow" class="show_fullinfo">{{ fullinfo }}</p>
          <div class="tabs_box ellipsis" v-if="detailInfo.tags.length > 0">
            <span class="info_time" style="width: 60px;vertical-align: baseline;">事件标签：</span>
            <span class="tabs" v-for="(tag,t) of detailInfo.tags" :key="t">{{tag}}</span>
          </div>
          <span class="info_link">原文链接：</span>
          <a :href="((detailInfo.webname == '小红书' || detailInfo.webname == '搜狐新闻') && detailInfo.webUrl) ? detailInfo.webUrl : detailInfo.url1"  class="view_original" style="margin-right:10px">{{detailInfo.url1}}</a>
          <div class="copy_box" @click="copyInfo(5)">
            <div class="copy_blue_icon"></div>
          </div>
        </div>
        <!-- 研判建议 -->
        <!-- <div class="judgment_suggess_box border_box flex">
          <div class="user_img_box">
            <img src="../../../assets/images/judgment/user_icon.svg" class="user_icon" />
          </div>
          <div class="suggess_box flex_1">
            <h4 class="suggess_title">研判建议</h4>
            <p class="suggess_txt">{{detailInfo.proposal}}</p>
          </div>
        </div> -->
        <!-- 内容 -->
        <div class="detail-video-box" v-if="detailInfo.videoUrls">
          <video
            id="detailVideo"
            :src="detailInfo.videoUrls"
            controls="controls"
            objectfit="contain"
            style="height: 100%;width: 100%;outline: none;background-color: #000;"
          ></video>
        </div>
        <div class="judgment_txt_box border_box">
          <div v-if="detailInfo.mediaSourceType === 11" class="title_box"><i></i><span>简介</span></div>
          <span v-html="detailInfo.content"></span>
          <div class="copy_box" @click="copyInfo(6)">
            <div class="copy_blue_icon"></div>
          </div>
        </div>
        <!-- <div class="judgment_video_box" v-if="detailInfo.smallVideo">
          <img v-if="!detailInfo.smallVideoCover" class="default_img" :src="defaultImageList[detailInfo.smallVideoType]"/>
          <img v-if="detailInfo.smallVideoCover" class="link_img" :src="detailInfo.smallVideoCover"/>
          <a :href="detailInfo.url">观看<span> 原视频 </span>请点击前往</a>
        </div> -->
        <!-- 抽帧OCR -->
        <div v-if="detailInfo.ocrContentList && detailInfo.ocrContentList.length"  class="judgment_txt_box border_box">
          <div class="title_box"><i></i><span>抽帧OCR</span></div>
          <div v-for="(item, i) of detailInfo.ocrContentList" :key="i">
            <span v-html="item.ocrtext"></span>
            <div v-if="i === detailInfo.ocrContentList.length - 1" class="copy_box" @click="copyInfo(7)">
              <div class="copy_blue_icon"></div>
            </div>
          </div>
        </div>
        <!-- 语音识别 -->
        <div v-if="detailInfo.istarAsr" class="judgment_txt_box border_box">
          <div class="title_box"><i></i><span>语音识别</span></div>
          <span v-html="detailInfo.istarAsr"></span>
          <div class="copy_box" @click="copyInfo(8)">
            <div class="copy_blue_icon"></div>
          </div>
        </div>
      </div>
      <!-- 相同信息列表 -->
      <div class="info_list_box border_box" v-if="sameInfoList.length > 0" :class="isIOS ? 'marginbotm2' : 'marginbotm'">
        <van-list
          v-model="loading"
          :finished="finished"
          :finished-text="((sameTotal < 100) ? '' : '此处显示100条信息')"
          @load="getSameList"
        >
          <h2 class="list_title">相同信息列表（{{sameTotal}}）</h2>
          <div class="info_list_item" v-for="(same,i) of sameInfoList" :key="i" :num="i+1">
            <a :href="same.url" class="list_item_title">{{same.title}}</a>
            <p class="list_item_info">
              <span class="list_item_time">{{same.publishTime}}</span>
              <span class="list_item_source">{{same.webname}}</span>
            </p>
          </div>
        </van-list>
      </div>
    </div>
    <!-- 下载 -->
    <!-- <div class="download_box border_box flex_between" v-if='yqmsorigin'>
      <div class="yqms_logo_box border_box">
        <img src="../../../assets/images/judgment/yqms_logo.svg" class="yqms_logo" />
        <span class="logo_txt">舆情秘书</span>
      </div>
      <a href="https://dl.istarshine.com/yqms/FBaddress/yqmsfb.html" class="download_btn border_box">下载</a>
    </div> -->
  </div>
</template>
<script>
import {handleClipboard} from '../../../assets/js/clipboard';
import { List,Toast,Notify } from 'vant';
import { getDetailsInfo , getSameWarningList } from '@/api/judgment'
import { wxShare } from '@/helpers/wxconfig'
import { getSimpleText } from '@/helpers/util.js'
import { getUserCopy } from '@/api/wechat'
import CONSTANTS from '@/helpers/constant'
import warningLevel from '@/components/warningLevel/warningLevel'
import store from '@/store'
let moment = require("moment");
export default {
  name: 'judgmentdetail',
  components: {
    "van-list": List,
    "warningLevel":warningLevel
  },
  data(){
    return {
      detailInfo: {
        title:'',                   //标题
        content:'',                 //内容
        url:'',                     //原文连接
        Base64url:'',               //base64 url
        author:'',                  //作者
        publishTime:'',             //发布时间
        orientation:'',             //倾向性  1 正 2负  3中
        isRead:'',                  //是否已读
        proposal:'',                //处置建议
        webname:'',                 //来源
        abstracts:'',               //摘要
        keyword:'',                 //关键词
        overseas:'',                //是否境外
        smallVideo:'',              //是否小视频 0 不是 1 是
        simhash:'',                 //信息simhash
        isReport:'',                //加入简报
        infoid:'',                  //infoid
        tags:[],                    //事件分类
        isMyAttention:'0',          //是否加入过关注    0 否 1是
        warningLevel:'',            //0：一般，1：中等，2：严重，3：高危
      },
      CONSTANT:{
        ...CONSTANTS
      },
      defaultImageList: {
        '1':require('../../../assets/images/smallvideo/volcano_list.png'),//火山
        '2':require('../../../assets/images/smallvideo/watermelon_list.png'),//西瓜
        '3':require('../../../assets/images/smallvideo/sp_list.png'),//秒拍
        '4':require('../../../assets/images/smallvideo/quickhand_list.png'),//快手
        '5':require('../../../assets/images/smallvideo/shakes_list.png'),//抖音
        '6':'',                                                   //微视
        '7':require('../../../assets/images/smallvideo/mp_list.png'),//美拍
        '8':require('../../../assets/images/smallvideo/bili_list.png'),//哔哩哔哩
        '10':require('../../../assets/images/smallvideo/qm_list.png'),//全民
      },
      sameInfoList: [],             //相同信息列表
      sameTotal: 0,                 //相同信息列表条数
      loading: false,
      finished: false,
      index: 0,
      uuid:'',                      //信息uuid
      simhash:'',                   //信息simhash
      infoid:'',                    //信息infoid
      isIOS: false,
      yqmsorigin: false,
      showCopyContent:false,
      isShow: false,
      fullinfo: '',
      windowBodyWidth: document.body.clientWidth,
      count1: 0,
      count2: 0,
      copyArr: [],
      copyInfoTemplate: [],
      userCopyTemplate: []
    }
  },
  computed: {
    leftWidth() {
      let len = this.getKeywordWidth(this.detailInfo.webname,24)
      if(len < 180) {
        return len
      } else {
        return 180
      }
    },
    centerWidth() {
      return  (this.windowBodyWidth * 2)  - this.leftWidth - 450
    }
  },
  methods: {
    showFullSourceinfo(info,width) {
      this.$refs.author.style.color = '#999'
      this.count1++
      this.count2 = 0
      let len = this.getKeywordWidth(info,24)
      if( len <= width) {
        this.isShow = false
        this.$refs.source.style.color = '#999'
      } else {
        if(this.count1 % 2) {
          this.isShow = true
          this.$refs.source.style.color = '#5090f1'
        } else {
          this.isShow = false
          this.$refs.source.style.color = '#999'
        }

        this.fullinfo = info
      }
    },
    showFullAuthorinfo(info,width) {
      this.$refs.source.style.color = '#999'
      this.count1 = 0
      this.count2++
      let len = this.getKeywordWidth(info,24)
      if( len <= width) {
        this.isShow = false
        this.$refs.author.style.color = '#999'
      } else {
        if(this.count2 % 2) {
          this.isShow = true
          this.$refs.author.style.color = '#5090f1'
        } else {
          this.$refs.author.style.color = '#999'
          this.isShow = false
        }
        this.fullinfo = info
      }
    },
    getKeywordWidth(words,fontSize) {
      const len = this.checksum(words) // 字符个数
      const keyLen = !!words && words.split(',').length
      const allLen = (len + keyLen - 1) * fontSize / 2
      return allLen
    },
    checksum(chars) {
      let sum = 0
      for (let i = 0; i < chars.length; i++) {
        const c = chars.charCodeAt(i)
        if ((c >= 0x0001 && c <= 0x007e) || (c >= 0xff60 && c <= 0xff9f)) {
          sum++
        } else {
          sum += 2
        }
      }
      return sum
    },
    queryData(){
      Toast.loading({
        duration: 0,       // 持续展示 toast
        mask: true,
        message: '加载中...'
      })
      let params = {
        id: this.uuid
      }
      getDetailsInfo(params).then(res => {
        Toast.clear();
        if(res.data.status == '0'){
          let result = res.data.result.data;
          if(result != ''){
            this.detailInfo.title = result.title;
            this.detailInfo.copyTitle = result.copyTitle;
            this.detailInfo.content = result.content;
            this.detailInfo.copyContent = result.copyContent;
            this.detailInfo.url = result.url;
            if(result.webname == '抖音') {
              const url = this.detailInfo.url
              this.detailInfo.url1 = url.split('####')[0].replace(/#orc/g, '').replace(/#att/g, '').replace(/#asr/g, '').replace(/iesdouyin/g, 'douyin')
            }else if(result.webname == '微信视频号') {
              this.detailInfo.url1 = result.appUrl?result.appUrl:result.url;
            }else {
              this.detailInfo.url1 = result.url;
            }
            // this.detailInfo.Base64url = Base64.encode(info.url);
            this.detailInfo.author = result.author;
            this.detailInfo._publishTime = result.publishTime;
            this.detailInfo.webUrl = result.webUrl;
            this.detailInfo._publishTime = result.publishTime;
            this.detailInfo.publishTime = moment(result.publishTime, "YYYYMMDDHHmmss").format('YYYY-MM-DD HH:mm:ss');
            this.detailInfo.copyPublishTime2 = moment(result.publishTime, "YYYYMMDDHHmmss").format('M月D日');
            this.detailInfo.orientation = result.orientation;
            this.detailInfo.authorInfo = result.authorInfo;
            this.detailInfo.isRead = result.isRead;
            this.detailInfo.webname = result.webname;
            this.detailInfo.proposal = result.proposal;
            this.detailInfo.warningLevel = result.warningLevel;
            this.detailInfo.copyAbstracts = result.copyAbstracts;
            this.detailInfo.abstracts = result.abstracts;
            this.detailInfo.simhash = result.simhash;
            this.detailInfo.infoid = result.infoId;
            this.detailInfo.keyword = result.keyword;
            this.detailInfo.postPlace = result.postPlace || '';
            this.detailInfo.visitCount = result.visitCount || '';
            this.detailInfo.praiseCount = result.praiseCount || '';
            this.detailInfo.ipRegion = result.ipRegion || '';
            this.detailInfo.overseas = result.overseas;
            this.detailInfo.isReport = result.isReport;
            this.detailInfo.isMyAttention = result.isMyAttention;
            this.detailInfo.replyNum = result.replyNum;
            this.detailInfo.forwardNum = result.forwardNum;
            this.detailInfo.smallVideo = result.smallVideo;
            this.detailInfo.smallVideoCover = result.smallVideoCover;
            this.detailInfo.smallVideoType = result.smallVideoType;
            this.detailInfo.mediaType = result.sourceType;
            this.detailInfo.authType = result.authType;
            this.detailInfo.fansCount = result.authorFansCount;
            this.detailInfo.warningClass = result.warningClass;
            this.detailInfo.tags = JSON.parse(result.tags);
            this.detailInfo.mediaSourceType = result.mediaSourceType
            this.detailInfo.ocrContentList = result.ocrContentList || ''
            this.detailInfo.istarAsr = result.istarAsr || ''
            this.detailInfo.copyIstarAsr = result.copyIstarAsr
            this.detailInfo.videoUrls = result.videoUrls || ''
            this.detailInfo.authorSourceId = result.authorSourceId || ''
            this.detailInfo.contentMentionRegionList = result.contentMentionRegionList
            this.detailInfo.area = result.contentMentionRegionList.length ?  result.contentMentionRegionList[0].split('-')[0] : ''
            this.detailInfo.firstIndustryTag = result.firstIndustryTag || ''
            this.detailInfo.secondIndustryTag = result.secondIndustryTag || ''
            this.detailInfo.subjectName = result.subjectName || ''
            this.detailInfo.catelogName = result.catelogName || ''
            this.detailInfo.ipRegion = result.ipRegion || ''
            this.detailInfo.authorCptLocation = result.authorCptLocation || ''
            this.detailInfo.className = result.catelogName || '';
            // 预警级别
            if (result.warningTimeArray && result.warningTimeArray.length) {
              this.detailInfo.warningTimeArray = this.handleWarningTimeArray(result.warningTimeArray)
            }
            wxShare(result.copyTitle,result.copyAbstracts,this);
          }
        }
      }).catch(err=>{
        console.log(err);
      });
    },
    // 处理时间记录
    handleWarningTimeArray(arr) {
      const strtime = 'YYYY-MM-DD HH:mm'
      arr.forEach(item => {
        item.warningTimes = moment(item.time).format(strtime)
        item.text = (item.level) ? this.CONSTANT.WARNING_LEVEL_INFO[item.level].TEXT : '—'
        item.desc = item.desc ? item.desc : '—'
      })
      return arr
    },
    getSameList(){
      // 异步更新数据
      setTimeout(() => {
        let params = {
          pageSize: 100,
          pageNum: 1,
          simhash: this.simhash,
          uuid: this.infoid
        }
        getSameWarningList(params).then(res => {
          if(res.data.status == '0'){
            let result = res.data.result.data || [];
            if(result.length > 0){
              this.sameTotal = result.length;
              for (let i in result) {
                result[i].publishTime = moment(result[i].publishTime, "YYYYMMDDHHmmss").format('YYYY-MM-DD HH:mm');
              }
              let DataItem=[result.slice(5*this.index,5*(this.index+1))];
              for (let i=0;i<DataItem.length;i++){
                for (let j=0;j<DataItem[i].length;j++){
                  this.sameInfoList.push(DataItem[i][j]);
                }
              }
              // 页数递增
              this.index++;
              // 加载状态结束
              this.loading = false;
              // 数据全部加载完成
              if (this.sameInfoList.length === result.length) {
                this.finished = true;
              }
            }else{
              this.sameInfoList = [];
            }
          }
        }).catch(err=>{
          console.log(err);
        });
      }, 500);
    },
    getUserCopy() {
      let params = {
        openid: store.state.userInfo.openid
      }
      const _this = this
      getUserCopy(params).then(function(res) {
        const {code,data} = res.data
        if (code === 200) {
          const {copyInfoTemplate,oldCopyInfoTemplate,userCopyTemplate} = data
          _this.copyArr = oldCopyInfoTemplate // 之前的
          _this.copyInfoTemplate = copyInfoTemplate  //新的
          _this.userCopyTemplate = userCopyTemplate  //新的
        }
      }).catch(err => {
        console.log(err, '请求失败！');
      });
    },
    newCopyInfo(copyInfoTemplate){
      const mediaSourceType = this.detailInfo.mediaSourceType || ''
      const webName = this.detailInfo.webname || ''
      const copyitemInfo = [...this.CONSTANT.COPYITEM]
      copyitemInfo.forEach(item=>{
        if (item.id === '20' && copyInfoTemplate.indexOf(item.replace) > -1){
          // 视频文件地址 并且包含
          if (mediaSourceType+'' === '11') {
            const s = this.getKeyValue(item.id, '', true)
            const rexp = new RegExp('\\' + item.replace, 'g')
            copyInfoTemplate = copyInfoTemplate.replace(rexp, s)
          }else{
            const str1 = `${item.name}:${item.replace}\n`
            const str2 = `${item.name}:${item.replace}`
            const str3 = `${item.replace}\n`
            const str4 = `${item.replace}`
            let regExpString = item.name + ':' + '\\' + item.replace
            // const regExpString = (copyInfoTemplate.indexOf(str) > -1) ? item.name + ':' + '\\' + item.replace + '\n' : item.name + ':' + '\\' + item.replace
            if (copyInfoTemplate.indexOf(str1) > -1) {
              regExpString = item.name + ':' + '\\' + item.replace + '\n'
            } else if (copyInfoTemplate.indexOf(str2) > -1) {
              regExpString = item.name + ':' + '\\' + item.replace
            } else if (copyInfoTemplate.indexOf(str3) > -1) {
              regExpString = `\\${item.replace}\n`
            } else if (copyInfoTemplate.indexOf(str4) > -1) {
              regExpString = `\\${item.replace}`
            }
            const rexp = new RegExp(regExpString, 'g')
            copyInfoTemplate = copyInfoTemplate.replace(rexp, '')
          }
        }else if (item.id === '18' || item.id === '19') {
          // 抖音
          if ((item.id === '18' && webName === '抖音') || (item.id === '19' && webName === '快手')) {
            const s = this.getKeyValue(item.id, '', true)
            const rexp = new RegExp('\\' + item.replace, 'g')
            copyInfoTemplate = copyInfoTemplate.replace(rexp, s)
          } else {
            // 不是抖音
            const str1 = `${item.name}:${item.replace}\n`
            const str2 = `${item.name}:${item.replace}`
            const str3 = `${item.replace}\n`
            const str4 = `${item.replace}`
            let regExpString = item.name + ':' + '\\' + item.replace
            // const regExpString = (copyInfoTemplate.indexOf(str) > -1) ? item.name + ':' + '\\' + item.replace + '\n' : item.name + ':' + '\\' + item.replace
            if (copyInfoTemplate.indexOf(str1) > -1) {
              regExpString = item.name + ':' + '\\' + item.replace + '\n'
            } else if (copyInfoTemplate.indexOf(str2) > -1) {
              regExpString = item.name + ':' + '\\' + item.replace
            } else if (copyInfoTemplate.indexOf(str3) > -1) {
              regExpString = `\\${item.replace}\n`
            } else if (copyInfoTemplate.indexOf(str4) > -1) {
              regExpString = `\\${item.replace}`
            }
            const rexp = new RegExp(regExpString, 'g')
            copyInfoTemplate = copyInfoTemplate.replace(rexp, '')
          }
        } else {
          const s = this.getKeyValue(item.id, '', true)
          console.log(s)
          const rexp = new RegExp('\\' + item.replace, 'g')
          copyInfoTemplate = copyInfoTemplate.replace(rexp, s)
        }

      })
      return copyInfoTemplate
    },
    copyInfo(type,index){
      let _this = this;
      let content = '';
      if(type == 1){//复制全部
        if(this.copyInfoTemplate && this.copyInfoTemplate.length){
          //新复制模版
          let template = this.copyInfoTemplate
          if(index+'' === '0'|| index){
            template = this.userCopyTemplate[index] ? this.userCopyTemplate[index].template : template
          }
          console.log(template)
          content = this.newCopyInfo(template)

        }else{
          this.copyArr.map(item=>{
            const name = store.state.userInfo.isShowFieldName ? `${item.name}：` : ''
            content += '\n' + this.getKeyValue(item.id,name)
          })
        }
      }
      if(type == 2){//复制标题和链接
        content = content + '标题：' + getSimpleText(this.detailInfo.copyTitle) + '\n';
        content = content + '链接：' + this.detailInfo.url1 + '\n';
      }
      if(type == 3){//复制标题和正文
        content = content + '标题：' + getSimpleText(this.detailInfo.copyTitle) + '\n';
        content = content + '正文：' + getSimpleText(this.detailInfo.copyContent);
      }
      if(type == 4){//复制标题
        content = content + '标题：' + getSimpleText(this.detailInfo.copyTitle);
      }
      if(type == 5){//复制链接
        content = content + this.detailInfo.url1;
      }
      if(type == 6){//复制正文
        content = content + '正文：' + getSimpleText(this.detailInfo.copyContent);
      }
      if(type == 7){//抽帧OCR
        let tempStr = ''
        this.detailInfo.ocrContentList.forEach(item=>{
          tempStr += getSimpleText(item.copyOcrtext)
        })
        content = content + '抽帧OCR：' + tempStr;
      }
      if(type == 8){//语音识别
        content = content + '语音识别：' + getSimpleText(this.detailInfo.copyIstarAsr);
      }
      handleClipboard(content, event, () => {
        Notify({
          message: '复制成功',
          duration: 1000,
          color: "",
          className: "notifyNew",
          background: ''
        });
        let params = {
          uuid: _this.uuid,
          infoType: '4' //1 专题 、2预警、3舆情研判微信端 、4推送预警微信端
        }
        _this.$store.commit('saveCopyInfo',params);
      }, () => {
        Notify({
          message: '复制失败！',
          duration: 1000,
          color: "",
          className: "notifyErr",
          background: ''
        });
      });
    },
    getKeyValue(id,name){
      let content = '';
      let tendency = '';
      let mediaTypeName = ''
      const authType = this.detailInfo.authType + '' || ''
      if(this.detailInfo.orientation == 1) {
        tendency = '正面';
      }else if(this.detailInfo.orientation == 2) {
        tendency = '负面';
      }else if(this.detailInfo.orientation == 3) {
        tendency = '中性';
      }
      // console.log('---------------33')
      // console.log(name)
      var itemdata = this.detailInfo
      switch(id) {
        case "1":
          content =  name + getSimpleText(this.detailInfo.copyTitle);
          break;
        case "2":
          content = name + this.detailInfo.url1;
          break;
        case "3":
          content = name + getSimpleText(this.detailInfo.copyAbstracts).getAbstract();
          break;
        case "4":
          var times =  moment(itemdata.publishTime, "YYYYMMDDHHmmss").format('YYYY-MM-DD HH:mm')
          content = name + times;
          break;
        case "5":
          content = name + this.detailInfo.webname;
          break;
        case "6":
          content = name + this.detailInfo.author;
          break;
        case "7":
          content = name + tendency;
          break;
        case "8":
          // isComment: 是否评论，0：非评论 1：评论，评论时不显示评论数和转发数
          content = name + this.detailInfo.replyNum;
          break;
        case "9":
          content = name + this.detailInfo.forwardNum;
          break;
        case "10":
          content = name + this.detailInfo.keyword;
          break;
        case '11' :
          if (authType === '3') {
            mediaTypeName = '蓝V'
          } else if (authType === '2') {
            mediaTypeName = '橙V'
          } else if (authType === '4') {
            mediaTypeName = '金V'
          } else {
            mediaTypeName = '普通用户'
          }
          content = name + mediaTypeName;
          break;
        case '12' :
          content = name + (this.detailInfo && this.detailInfo.fansCount ? this.detailInfo.fansCount : 0);
          break;
        case '13' : // 单位
          content = name + store.state.userInfo.unitName;
          break;
        case '14' : // 作者ID
          content = name + (this.detailInfo && this.detailInfo.authorSourceId ? this.detailInfo.authorSourceId : '');
          break;
        case '15' : // 涉事省份
          content = name + (this.detailInfo && this.detailInfo.area ? this.detailInfo.area : '');
          break;
        case '16' : // 涉事地域
          var region = this.getRegionData(itemdata)
          content = name + region;
          break;
        case '17' : // 日期
          var copyPublishTimeStr = this.detailInfo.publishTime
          if(this.detailInfo.copyPublishTime2){
            copyPublishTimeStr = this.detailInfo.copyPublishTime2
          }
          content = name + copyPublishTimeStr;
          break;
        case '18' : // 抖音号
          var authorUserAccountNum = this.detailInfo.authorInfo.authorUserAccountNum || ''
          content = name + authorUserAccountNum;
          break;
        case '19' : // 抖音号
          var authorUserAccountNum2 = this.detailInfo.authorInfo.authorUserAccountNum || ''
          content = name + authorUserAccountNum2;
          break;
        case '20' : // 抖音号
          if (this.detailInfo.mediaSourceType + '' === '11') {
            var videoUrls = this.detailInfo.videoUrls || ''
            content = name + videoUrls;
          }
          break;
        case '21' : // 签到地
          var postPlace = this.detailInfo.postPlace || ''
          var newStr = postPlace.replace(/<[^>]*>/g, '')
          content = name + newStr;
          break;
        case '22' : // 阅读数
          var visitCount = this.detailInfo.visitCount || 0
          content = name + visitCount;
          break;
        case '23' : // 点赞数
          var praiseCount = this.detailInfo.praiseCount || 0
          content = name + praiseCount;
          break;
        case '24' : // 标签
          // var Tag = (this.detailInfo.firstIndustryTag && this.detailInfo.secondIndustryTag) ? this.detailInfo.firstIndustryTag + '-' + this.detailInfo.secondIndustryTag : (this.detailInfo.firstIndustryTag) ? this.detailInfo.firstIndustryTag : ''
          var Tag = ''
          if (this.detailInfo.industryTags) {
            Tag = this.detailInfo.industryTags.join('、')
          }
          content = name + Tag
          break;
        case '25' : // 专题名称
          var subjectName = this.detailInfo.subjectName || ''
          content = name + subjectName
          break;
        case '26' : // 专题分类名称
          var catelogName = this.detailInfo.catelogName || ''
          content = name + catelogName
          break;
        case '27' : // 信息发布地域
          var ipRegion = this.detailInfo.ipRegion || ''
          return name + ipRegion
        case '28' : // 小红书号
          var authorUserAccountNum1 = this.detailInfo.authorInfo.authorUserAccountNum || ''
          return name + authorUserAccountNum1
        case '29' : // 作者地域
          var authorCptLocation = (this.detailInfo.authorCptLocation && this.detailInfo.authorCptLocation.length) ? this.detailInfo.authorCptLocation[0] : ''
          content = name + authorCptLocation;
          break;
        default:
          if (store.state.userInfo.isShowFieldName) {
            content = name;
          }
          break;
      }
      return content
    },
    hideCopyContentfun(){
      this.showCopyContent = false;
      this.isShow = false
      this.count1 = 0
      this.count2 = 0
      this.$refs.author.style.color = '#999'
      this.$refs.source.style.color = '#999'
    },
    showCopyContentfun(){
      this.showCopyContent = true;
    },
    getRegionData(itemdata){
      const provinceName = this.userInfo.provinceName // 省name
      const cityName = this.userInfo.cityName // 市name
      const countryName = this.userInfo.countryName // 县name
      let strData = provinceName
      if (cityName) {
        strData = strData + '-' + cityName
      }
      if (countryName) {
        strData = strData + '-' + countryName
      }
      const cmr = itemdata.contentMentionRegionList || []
      if (cmr.includes(strData)) {
        return strData
      } else {
        return cmr.length ? cmr[0] : ''
      }
    },
    goback(){
      window.history.go(-1);
    },
  },
  mounted() {
    let query = this.$route.query;
    this.uuid = query.uuid;
    this.simhash = query.simhash;
    this.infoid = query.infoid;
    this.queryData();
    this.getSameList();
    this.getUserCopy();
    let userAgent = navigator.userAgent || '';
    // this.isAndroid = userAgent.indexOf('Android') > -1 || userAgent.indexOf('Adr') > -1;
    this.isIOS = !!userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import url("./detail.css");
</style>
